<template>
  <el-container class="full-height">
    <el-aside width="300px" class="sidebar">
      <div class="user-list">
        <h3>在线人员列表</h3>
        <div class="user-list-content">
          <ul>
            <li v-for="user in onlineUsers" :key="user" @click="selectUserr(user)"
              :class="{ selected: selectedUser === user }">
              {{ user }}
            </li>
          </ul>
        </div>
      </div>
      <div class="buttons">
        已选择{{ selectedUser }}
        <button @click="startScreenShare">共享屏幕</button>
        <button @click="startVideoCall">视频通话</button>
        当前用户:  {{ username }}
      </div>
    </el-aside>

    <el-main class="full-height main-container">
      <div id="large-video" class="video-player large-video">
        <video id="remote-video" autoplay playsinline></video>
      </div>
      <div id="small-video" class="video-player small-video">
        <video id="local-video" autoplay playsinline muted></video>
      </div>
      <button class="switch-button" @click="switchPosition">切换视图</button>
      <button v-if="isShowHangUp" class="hangUpCall" @click="ShangUpCall">挂断</button>
    </el-main>
  </el-container>
  <About v-if="isShowAbout" @message-to-parent="receiveMessageFromChild" :callName="callName" :serveType="serveType">
  </About>
  <Home v-if="isShowHome" :message="PopUpText"></Home>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import About from './AboutView.vue';
import Home from './HomeView.vue';

const username = localStorage.getItem('username');
const isLocalSmall = ref(false);
const isRemoteConnected = ref(false);
const onlineUsers = ref([]);
const selectedUser = ref(null);
const PopUpText = ref("正在向对方请求通话...");
const isShowHome = ref(false);
const isShowAbout = ref(false);
const callName = ref('');
const serveType = ref('');
const isShowHangUp = ref(false);

// 在 script 部分
const selectUserr = (user) => {
  selectedUser.value = user;
};

const receiveMessageFromChild = async (message) => {
  if (message) {
    sendMessage({ type: "await", info: " ", from: username, to: selectedUser.value });
    isShowAbout.value = false;
    console.log("收到消息：", message);
    console.log("共享类型", serveType.value);
    await createStream(serveType.value);
    sendMessage({ type: "ready", info: " ", from: username, to: selectedUser.value });
  } else {
    sendMessage({ type: "callRejected", info: " ", from: username, to: selectedUser.value });
    isShowAbout.value = false;
  }
};

let socket;
const initWebSocket = () => {
  socket = new WebSocket('wss://webrtc.ywystation.cn:8090/' + username);
  socket.onopen = () => console.log('WebSocket 连接成功');
  socket.onmessage = onMessage;
  socket.onclose = () => alert('连接断开');
};

const onMessage = async (event) => {
  const msg = JSON.parse(event.data);
  console.log('收到消息：', msg.type);

  switch (msg.type) {
    case 'join':
      onlineUsers.value.push(msg.info);
      break;
    case 'ice':
      await handleIceCandidate(msg.info);
      break;
    case 'leave':
      onlineUsers.value = onlineUsers.value.filter(user => user !== msg.info);
      break;
    case 'onlineUsers':
      onlineUsers.value = msg.info;
      break;
    case 'callRequest':
      callName.value = msg.from;
      serveType.value = msg.info;
      isShowAbout.value = true;

      break;
    case 'await':
      PopUpText.value = '对方已接听,等待对方准备...';
      break;
    case 'ready':
      PopUpText.value = '对方已就绪,正在建立连接...';
      await createOffer(serveType.value);
      break;
    case 'giveOffer':
      await createAnswer(msg);
      isShowHangUp.value = true;
      break;
    case 'callAccepted':
      await addAnswer(msg);
      break;
    case 'callRejected':
      PopUpText.value = '对方挂断,程序结束';
      setTimeout(cleanUpState, 3000);
      break;
    case 'callHangUp':
      hangUpCall();
      break;
  }
};

const sendMessage = (message) => {
  if (socket.readyState === WebSocket.OPEN) {
    socket.send(JSON.stringify(message));
  } else {
    alert('连接没有开启');
  }
};

// 创建 RTCPeerConnection
let peerConnection = createPeerConnection();

// 创建 PeerConnection 实例
function createPeerConnection() {
  const pc = new RTCPeerConnection({
    iceServers: [{ urls: 'stun:stun.l.google.com:19302' }],
  });

  pc.onicecandidate = (event) => {
    if (event.candidate) {
      sendMessage({ type: "ice", info: event.candidate, from: username, to: selectedUser.value });
    }
  };

  pc.ontrack = (event) => {
    event.streams[0].getTracks().forEach(track => remoteStream.value.addTrack(track));
    document.getElementById('remote-video').srcObject = remoteStream.value;
  };

  pc.oniceconnectionstatechange = () => {
    console.log('ICE Connection State: ', pc.iceConnectionState);
  };

  pc.onconnectionstatechange = () => {
    console.log('Connection State: ', pc.connectionState);
  };

  return pc;
}

const localStream = ref(null);
const remoteStream = ref(new MediaStream());

const startScreenShare = async () => {
  if (!selectedUser.value) {
    alert('请选择一个用户');
    return;
  }
  await createStream('Share');
  sendMessage({ type: "callRequest", info: "Share", from: username, to: selectedUser.value });
  isShowHome.value = true;
};

const startVideoCall = async () => {
  if (!selectedUser.value) {
    alert('请选择一个用户');
    return;
  }
  await createStream();
  sendMessage({ type: "callRequest", info: "Video", from: username, to: selectedUser.value });
  isShowHome.value = true;
};

const createStream = async (type) => {
  if (localStream.value) {
    localStream.value.getTracks().forEach(track => track.stop());
  }

  if (type == "Share") {
    console.log("开始创建屏幕")
    localStream.value = await navigator.mediaDevices.getDisplayMedia({ video: true, audio: true });
  } else {
    console.log("开始创建摄像")
    localStream.value = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
  }

  document.getElementById('local-video').srcObject = localStream.value;

  localStream.value.getTracks().forEach(track => {
    peerConnection.addTrack(track, localStream.value);
  });

  document.getElementById('remote-video').srcObject = remoteStream.value;
};

const hangUpCall = () => {
  cleanUpStreams();
  resetPeerConnection();
  cleanUpState();
};

const cleanUpStreams = () => {
  if (localStream.value) {
    localStream.value.getTracks().forEach(track => track.stop());
    localStream.value = null;
  }

  if (remoteStream.value) {
    remoteStream.value.getTracks().forEach(track => track.stop());
    remoteStream.value = new MediaStream(); // Reset remoteStream to new instance
  }

  document.getElementById('local-video').srcObject = null;
  document.getElementById('remote-video').srcObject = null;
};

const resetPeerConnection = () => {
  if (peerConnection) {
    peerConnection.onicecandidate = null;
    peerConnection.ontrack = null;
    peerConnection.close();
    peerConnection = null;
  }
  peerConnection = createPeerConnection();
};

const cleanUpState = () => {
  isRemoteConnected.value = false;
  isShowHangUp.value = false;
  selectedUser.value = null;
  PopUpText.value = '正在向对方请求通话...';
  isShowHome.value = false;
};

const ShangUpCall = () => {
  sendMessage({ type: "callHangUp", info: " ", from: username, to: selectedUser.value });
  hangUpCall();
};

const handleIceCandidate = async (candidate) => {
  if (candidate) {
    console.log('收到 ICE 候选:', candidate);
    try {
      await peerConnection.addIceCandidate(candidate);
    } catch (error) {
      console.error('添加 ICE 候选失败:', error);
    }
  }
};

const createOffer = async () => {
  const offer = await peerConnection.createOffer();
  await peerConnection.setLocalDescription(offer);
  sendMessage({ type: 'giveOffer', from: username, to: selectedUser.value, info: offer });
};

const createAnswer = async (Remoteoffer) => {
  if (Remoteoffer) {
    await peerConnection.setRemoteDescription(new RTCSessionDescription(Remoteoffer.info));
    const answer = await peerConnection.createAnswer();
    await peerConnection.setLocalDescription(answer);
    sendMessage({ type: 'callAccepted', from: username, to: Remoteoffer.from, info: answer });
  }
};

const addAnswer = async (Remoteoffer) => {
  if (Remoteoffer && Remoteoffer.info && Remoteoffer.info.sdp) {
    const remoteDesc = new RTCSessionDescription(Remoteoffer.info);
    if (!peerConnection.currentRemoteDescription) {
      await peerConnection.setRemoteDescription(remoteDesc);
      console.log("RemoteDescription 成功:", remoteDesc);
    }
    isShowHome.value = false;
    isShowHangUp.value = true;
    isRemoteConnected.value = true;
  }
};

const selectUser = (user) => {
  selectedUser.value = user;
};

const switchPosition = () => {
  const smallVideo = document.getElementById("small-video");
  const largeVideo = document.getElementById("large-video");

  if (isLocalSmall.value) {
    smallVideo.className = "video-player small-video";
    largeVideo.className = "video-player large-video";
  } else {
    smallVideo.className = "video-player large-video";
    largeVideo.className = "video-player small-video";
  }

  isLocalSmall.value = !isLocalSmall.value;
};

onMounted(initWebSocket);
</script>


<style scoped>
li {
  width: 100%;
  height: 20px;
  background: #9beeb4;
  padding: 3px 0;
  margin: 2px 0;
  border-left: 1px solid #000;
  border-right: 1px solid #000;
  list-style-type: none;
  user-select: none;
}

.full-height {
  height: 100vh;
  display: flex;
}

.el-container {
  display: flex;
  width: 100%;
}

.el-aside {
  width: 300px;
  background-color: #f3f3f3;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.el-main {
  flex-grow: 1;
  position: relative;
  /* background-color: #000; */
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-sizing: border-box;
  padding: 2px !important;
}

video {
  width: 100%;
  height: 100%;
  margin: 0 !important;
  box-sizing: border-box;
}

.video-player {
  transition: all 0.5s ease;
  box-sizing: border-box;
}

#local-video {
  background: #000;
}

.large-video {
  width: 100%;
  height: 100%;
  /* background: #ee2e2e; */
  box-sizing: border-box;
}

.small-video {
  position: absolute;
  width: 250px;
  height: 140px;
  top: 10px;
  right: 10px;
  border: 2px solid #fff;
  box-sizing: border-box;
}

.switch-button {
  position: absolute;
  bottom: 20px;
  left: 20px;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
}

.hangUpCall {
  position: absolute;
  bottom: 20px;
  right: 20px;
  padding: 10px 20px;
  font-size: 16px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  background-color: rgba(252, 71, 71);
}

.buttons {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

button {
  padding: 10px;
  font-size: 14px;
  cursor: pointer;
  box-sizing: border-box;
}

.selected {
  background-color: #e9bdda;
  /* 选择你喜欢的颜色 */
  /* 可以增加字体粗细 */
}
</style>
